import { ApiAbstract } from '../abstract';

export class ApiImport extends ApiAbstract<any, any> {}
